import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Reveal from "@/components/Reveal";

export default function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const email = new FormData(e.currentTarget).get("email");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-4 pb-24 pt-32" data-testid="forgot-password-page">
      <Reveal>
        <div className="text-center">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-leaf">Locked out?</p>
          <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-forest">RESET IT.</h1>
        </div>
        <div className="mt-8 rounded-3xl border border-sand bg-white p-6 sm:p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <p className="font-display text-lg font-extrabold text-forest">Check your inbox.</p>
              <p className="mt-2 text-sm text-ink/60">If that email has an account, a reset link is on its way. It works once and expires in an hour.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <label className="block">
                <span className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-ink/60">Account email</span>
                <input data-testid="forgot-email-input" name="email" type="email" required placeholder="you@example.com" className="w-full rounded-xl border border-sand bg-cream/50 px-4 py-3 text-sm font-semibold focus:border-leaf focus:bg-white" />
              </label>
              <button data-testid="forgot-submit" disabled={loading} className="w-full rounded-full bg-leaf py-3.5 text-sm font-extrabold uppercase tracking-wide text-white transition-all hover:bg-forest active:scale-[0.98] disabled:opacity-60">
                {loading ? "Sending..." : "Email me a reset link"}
              </button>
            </form>
          )}
          <Link to="/account" data-testid="forgot-back-link" className="mt-6 block text-center text-xs font-bold uppercase tracking-wider text-ink/50 hover:text-leaf">Back to log in</Link>
        </div>
      </Reveal>
    </div>
  );
}
